import { pageViewTypes } from "@constants/tracking";
import FaqsContainer from "@features/faqs/components/FaqsContainer";
import useAnalytics from "@hooks/useAnalytics";
import { useMemo } from "react";

const FaqsRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.faq,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	return <FaqsContainer />;
};

export default FaqsRoute;
